/* FootDrop — deterministic print-preview profiles. No font is presented as official. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FDPrintProfiles = api;
}(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var BASE = {
    fontFamily: 'FDPrintName, "Arial Narrow", Arial, sans-serif',
    nameFontFamily: 'FDPrintName, "Arial Narrow", Arial, sans-serif',
    numberFontFamily: 'FDPrintNumber, Impact, "Arial Narrow", Arial, sans-serif',
    fontWeight: 600, numberFontWeight: 500, nameSize: 0.05, numberSize: 0.245,
    nameTracking: 0.004, ink: '#ffffff', strokeColor: '#111318', strokeWidth: 0.001,
    verifiedFont: false, indicative: true,
    note: 'Aperçu indicatif : la police et le placement peuvent varier selon le flocage du modèle.'
  };
  var profiles = {
    'ligue-1': { id: 'ligue-1', label: 'Ligue 1', league: 'Ligue 1', nameTracking: 0.0045, numberSize: 0.25 },
    'premier-league': { id: 'premier-league', label: 'Premier League', league: 'Premier League', nameTracking: 0.0035, numberSize: 0.245 },
    'la-liga': { id: 'la-liga', label: 'LaLiga', league: 'LaLiga', nameTracking: 0.003, numberSize: 0.24 },
    'serie-a': { id: 'serie-a', label: 'Serie A', league: 'Serie A', nameTracking: 0.004, numberSize: 0.25 },
    'bundesliga': { id: 'bundesliga', label: 'Bundesliga', league: 'Bundesliga', nameTracking: 0.0035, numberSize: 0.245 },
    championship: { id: 'championship', label: 'Championship', league: 'EFL Championship', nameTracking: 0.0035, numberSize: 0.245 },
    nation: { id: 'nation', label: 'Sélection nationale', league: null, nameTracking: 0.005, numberSize: 0.24 },
    retro: { id: 'retro', label: 'Rétro', league: null, nameTracking: 0.005, numberSize: 0.245 },
    concept: { id: 'concept', label: 'Concept', league: null, nameTracking: 0.004, numberSize: 0.24 },
    neutral: { id: 'neutral', label: 'Personnalisation', league: null, nameTracking: 0.004, numberSize: 0.24 }
  };

  // Only images inspected as unprinted backs belong here. Never infer a back from its gallery index.
  var verifiedPhotos = {
  "16116503642492": {"fan":{"mediaId":"69515834786172","variantEvidence":"reviewed_embroidered_crest_climacool_fan_short","geometry":{"centerX":0.5,"nameY":0.275,"numberY":0.47,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.25}}},
  "16116503576956": {"fan":{"mediaId":"69515834327420","variantEvidence":"reviewed_standard_fan_short_official_away_match","geometry":{"centerX":0.5,"nameY":0.28,"numberY":0.48,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16114814976380": {"fan":{"mediaId":"69501915627900","variantEvidence":"reviewed_embroidered_cannon_adidas_fan_short","geometry":{"centerX":0.5,"nameY":0.28,"numberY":0.48,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16116689895804": {"fan":{"mediaId":"69517410042236","variantEvidence":"reviewed_embroidered_trefoil_climacool_fan_short","geometry":{"centerX":0.5,"nameY":0.29,"numberY":0.49,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.255}}},
  "16116684423548": {"fan":{"mediaId":"69517346603388","variantEvidence":"reviewed_fan_short_official_checkerboard_third_match","geometry":{"centerX":0.5,"nameY":0.285,"numberY":0.48,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16114814878076": {"fan":{"mediaId":"69501915103612","variantEvidence":"reviewed_embroidered_crest_climacool_fan_short","geometry":{"centerX":0.505,"nameY":0.55,"numberY":0.417,"bottomY":0.69,"nameSize":0.035,"nameMaxWidth":0.3,"numberHeight":0.18,"numberMaxWidth":0.25}}},
  "16116696482172": {"fan":{"mediaId":"69517460799868","variantEvidence":"reviewed_fan_short_official_white_trefoil_away_match","geometry":{"centerX":0.505,"fixedTopY":0.31,"fixedTopSize":0.045,"nameY":0.65,"numberY":0.485,"bottomY":0.77,"nameSize":0.044,"nameMaxWidth":0.36,"numberHeight":0.235,"numberMaxWidth":0.29}}},
  "16116686946684": {"fan":{"mediaId":"69517375963516","variantEvidence":"reviewed_replica_cut_fan_short_official_third_match","geometry":{"centerX":0.505,"nameY":0.30,"numberY":0.475,"bottomY":0.72,"nameSize":0.052,"nameMaxWidth":0.38,"numberHeight":0.255,"numberMaxWidth":0.31}}},
  "16116684128636": {"fan": {"mediaId": "69517345227132", "variantEvidence": "supplier_254096968_fan_short_sleeve_official_third_match", "geometry": {"centerX":0.49,"nameY":0.27,"numberY":0.43,"bottomY":0.7,"nameMaxWidth":0.38,"numberHeight":0.21,"numberMaxWidthThree":0.36}}},
  "16116686127484": {"fan": {"mediaId": "69517373440380", "variantEvidence": "supplier_254096362_replica_cut_official_away_match", "geometry": {"centerX":0.5,"nameY":0.29,"numberY":0.48,"bottomY":0.71,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16116682817916": {"fan": {"mediaId": "69517326549372", "variantEvidence": "supplier_254097241_replica_cut_official_third_match", "geometry": {"centerX":0.5,"nameY":0.31,"numberY":0.50,"bottomY":0.72,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16116698153340": {"fan": {"mediaId": "69517465092476", "variantEvidence": "supplier_254093970_replica_cut_stitched_crest", "geometry": {"centerX":0.5,"nameY":0.31,"numberY":0.49,"bottomY":0.72,"nameMaxWidth":0.38,"numberHeight":0.26}}},
  "16116320862588": {"default": {"mediaId": "69515173626236", "geometry": {"centerX":0.5,"nameY":0.26,"numberY":0.47,"bottomY":0.7,"nameMaxWidth":0.37,"numberHeight":0.26,"numberMaxWidthThree":0.36}}},
  "16116671152508": {"default": {"mediaId": "69517240664444", "geometry": {"bottomY":0.7,"centerX":0.5,"nameMaxWidth":0.38,"nameY":0.27,"numberHeight":0.255,"numberMaxWidthThree":0.38,"numberY":0.485}}},
  "16116669350268": {"default": {"mediaId": "69517202489724", "geometry": {"bottomY":0.7,"centerX":0.5,"nameMaxWidth":0.38,"nameY":0.27,"numberHeight":0.255,"numberMaxWidthThree":0.38,"numberY":0.485}}},
  "16116668858748": {"default": {"mediaId": "69517199180156", "geometry": {"centerX":0.5,"nameY":0.265,"numberY":0.48,"bottomY":0.7,"nameMaxWidth":0.37,"numberHeight":0.26,"numberMaxWidthThree":0.36}}},
  "16116667613564": {"default": {"mediaId": "69517183779196", "geometry": {"bottomY":0.7,"centerX":0.5,"nameMaxWidth":0.38,"nameY":0.27,"numberHeight":0.255,"numberMaxWidthThree":0.38,"numberY":0.485}}},
  "16116667515260": {
    "default": {
      "mediaId": "69517183058300",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.46,
        "bottomY": 0.71,
        "numberHeight": 0.25,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116667482492": {
    "default": {
      "mediaId": "69517182796156",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.47,
        "bottomY": 0.71,
        "numberHeight": 0.25,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116504199548": {
    "fan": {
      "mediaId": "69515838423420",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.48,
        "bottomY": 0.7,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116693172604": {
    "fan": {
      "mediaId": "69517439238524",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.26,
        "numberY": 0.43,
        "bottomY": 0.7,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.21,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517199180156",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.265,
        "numberY": 0.48,
        "bottomY": 0.7,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.26,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116700643708": {
    "player": {
      "mediaId": "69515173626236",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.26,
        "numberY": 0.47,
        "bottomY": 0.7,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.26,
        "numberMaxWidthThree": 0.36
      }
    },
    "fan": {
      "mediaId": "69517512376700",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116690780540": {
    "fan": {
      "mediaId": "69517412663676",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-f684d2741e4f802c7f44461c.jpg?v=1789216971",
      "geometry": {
        "centerX": 0.508,
        "nameY": 0.29,
        "numberY": 0.4725,
        "bottomY": 0.655,
        "nameMaxWidth": 0.33,
        "numberHeight": 0.245
      },
      "ink": "#f6f5ee",
      "inkVerified": true
    },
    "player": {
      "mediaId": "69517212483964",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-621c127bd7ecf4a08f262403.jpg?v=1789215004",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.28,
        "numberY": 0.4625,
        "bottomY": 0.65,
        "nameMaxWidth": 0.34,
        "numberHeight": 0.245
      },
      "ink": "#f6f5ee",
      "inkVerified": true
    }
  },
  "16116503380348": {
    "fan": {
      "mediaId": "69515832557948",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/01_3b2db201-d69d-4bf1-8211-c19afe9fabf6.jpg?v=1789187233",
      "geometry": {
        "centerX": 0.501,
        "nameY": 0.267,
        "numberY": 0.48,
        "bottomY": 0.65,
        "nameMaxWidth": 0.36,
        "numberHeight": 0.265
      },
      "ink": "#152550",
      "inkVerified": false
    },
    "player": {
      "mediaId": "69517546127740",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-4e057710a3ca6ac153d9e361.jpg?v=1789218446",
      "geometry": {
        "centerX": 0.471,
        "nameY": 0.265,
        "numberY": 0.46,
        "bottomY": 0.755,
        "nameMaxWidth": 0.39,
        "numberHeight": 0.27
      },
      "ink": "#152550",
      "inkVerified": false
    }
  },
  "16116672004476": {
    "player": {
      "mediaId": "69517244629372",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-8c8489461b314436d358c57d.jpg?v=1789215406",
      "geometry": {
        "centerX": 0.491,
        "nameY": 0.285,
        "numberY": 0.49,
        "bottomY": 0.785,
        "nameMaxWidth": 0.4,
        "numberHeight": 0.265
      },
      "ink": "#F7F7F1",
      "inkVerified": false
    }
  },
  "16116693270908": {
    "fan": {
      "mediaId": "69517439762812",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-e37983e9d0ef5295dd2fc312.jpg?v=1789217524",
      "geometry": {
        "centerX": 0.508,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.36,
        "numberHeight": 0.265
      },
      "ink": "#F5F3DD",
      "inkVerified": false
    },
    "player": {
      "mediaId": "69517202751868",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-8208be3c2e84613cd107ca25.jpg?v=1789214824",
      "geometry": {
        "centerX": 0.49,
        "nameY": 0.255,
        "numberY": 0.46,
        "bottomY": 0.79,
        "nameMaxWidth": 0.4,
        "numberHeight": 0.265
      },
      "ink": "#F5F3DD",
      "inkVerified": false
    }
  },
  "16116668531068": {
    "player": {
      "mediaId": "69517196525948",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-a674e014c9522d23a3c14018.jpg?v=1789214825",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116331610492": {
    "player": {
      "mediaId": "69515121394044",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/09_560e53b1-ea2d-4f02-a904-ae440f162d6d.jpg?v=1789184803",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      },
      "ink": "#fab936",
      "inkVerified": true
    }
  },
  "16116690125180": {
    "fan": {
      "mediaId": "69517410795900",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-dfd0688ddc43fb6a86164f3d.jpg?v=1789216970",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517203243388",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-701157373c5b9a1612f30739.jpg?v=1789214825",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116501348732": {
    "fan": {
      "mediaId": "69515802706300",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/05_6718210e-4475-4b53-ba5d-134c026a7390.jpg?v=1789187135",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116503544188": {
    "fan": {
      "mediaId": "69515834261884",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/07_1cbc2231-c4b3-4ba4-8fa7-d7ee215f4eef.jpg?v=1789187255",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517196525948",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-a674e014c9522d23a3c14018.jpg?v=1789214825",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116503314812": {
    "fan": {
      "mediaId": "69515832230268",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/04_624837b5-ff57-4f2e-95cc-bb1f733d9446.jpg?v=1789187232",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69502410621308",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/01_a92a8b78-a1cd-480a-9077-35d4b2c08f64.jpg?v=1789062521",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116352450940": {
    "default": {
      "mediaId": "69515032658300",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/01_e62ea6f4-d9f2-435c-8207-2502fe270fca.jpg?v=1789184569",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116686094716": {
    "default": {
      "mediaId": "69517373374844",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-3374c6fc24fc4e96c908fd7f.jpg?v=1789216624",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116699791740": {
    "default": {
      "mediaId": "69517510476156",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-ee4025d9d123d29590cf2731.jpg?v=1789217997",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16114813665660": {
    "player": {
      "mediaId": "69501907861884",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.48,
        "bottomY": 0.71,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116354220412": {
    "default": {
      "mediaId": "69515022991740",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/01_3daa5e78-030d-435c-b14c-4d6b5e7fbdb2.jpg?v=1789184551",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116699660668": {
    "fan": {
      "mediaId": "69517510148476",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-53cdf2616d78c717bb64b031.jpg?v=1789217998",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116693369212": {
    "fan": {
      "mediaId": "69517440319868",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/fd-49aa1b26f938c7e01f1d397e.jpg?v=1789217524",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.485,
        "bottomY": 0.69,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.265,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69501907140988",
      "url": "https://cdn.shopify.com/s/files/1/0966/9024/1916/files/03_0ca30b83-9652-4413-8917-c53f58cbcc03.jpg?v=1789060249",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.27,
        "numberY": 0.485,
        "bottomY": 0.7,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.38
      }
    }
  },
  "16116161053052": {
    "fan": {
      "mediaId": "69511567278460",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517244629372",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116700414332": {
    "default": {
      "mediaId": "69517511426428",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116160954748": {
    "default": {
      "mediaId": "69511566819708",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116694221180": {
    "default": {
      "mediaId": "69517443432828",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.31,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116683538812": {
    "default": {
      "mediaId": "69517343359356",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.34,
        "numberY": 0.52,
        "bottomY": 0.74,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116683932028": {
    "default": {
      "mediaId": "69517344801148",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.32,
        "numberY": 0.51,
        "bottomY": 0.73,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116685373820": {
    "fan": {
      "mediaId": "69517350404476",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517201834364",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.485,
        "bottomY": 0.705,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116503675260": {
    "default": {
      "mediaId": "69515834917244",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116699824508": {
    "default": {
      "mediaId": "69517510738300",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.33,
        "numberY": 0.53,
        "bottomY": 0.75,
        "numberHeight": 0.22,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116700283260": {
    "default": {
      "mediaId": "69517510803836",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.32,
        "numberY": 0.52,
        "bottomY": 0.74,
        "numberHeight": 0.22,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16114814288252": {
    "fan": {
      "mediaId": "69501911433596",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.47,
        "bottomY": 0.69,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517244825980",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.285,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16114813239676": {
    "default": {
      "mediaId": "69501905109372",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.28,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116682162556": {
    "default": {
      "mediaId": "69517323862396",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.31,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116695073148": {
    "fan": {
      "mediaId": "69517445497212",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.31,
        "numberY": 0.5,
        "bottomY": 0.72,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517215695228",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.31,
        "numberY": 0.5,
        "bottomY": 0.72,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116686258556": {
    "fan": {
      "mediaId": "69517373866364",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517186236796",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.3,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116501447036": {
    "fan": {
      "mediaId": "69515806900604",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.36,
        "numberY": 0.52,
        "bottomY": 0.74,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116762018172": {
    "player": {
      "mediaId": "69518308475260",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.36,
        "numberY": 0.52,
        "bottomY": 0.74,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116689240444": {
    "fan": {
      "mediaId": "69517380682108",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.355,
        "numberY": 0.52,
        "bottomY": 0.74,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69501906026876",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.35,
        "numberY": 0.51,
        "bottomY": 0.73,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116685767036": {
    "default": {
      "mediaId": "69517351059836",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.35,
        "numberY": 0.51,
        "bottomY": 0.73,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16114813796732": {
    "default": {
      "mediaId": "69501908582780",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116503609724": {
    "fan": {
      "mediaId": "69515834491260",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116690485628": {
    "fan": {
      "mediaId": "69517412467068",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.46,
        "bottomY": 0.71,
        "numberHeight": 0.25,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517183058300",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.46,
        "bottomY": 0.71,
        "numberHeight": 0.25,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116700545404": {
    "fan": {
      "mediaId": "69517512081788",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.245,
        "numberY": 0.4,
        "bottomY": 0.71,
        "numberHeight": 0.205,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517201932668",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.48,
        "bottomY": 0.7,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116699726204": {
    "default": {
      "mediaId": "69517510214012",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.49,
        "bottomY": 0.71,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116685472124": {
    "default": {
      "mediaId": "69517350928764",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.3,
        "numberY": 0.51,
        "bottomY": 0.73,
        "numberHeight": 0.255,
        "nameMaxWidth": 0.38,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116695597436": {
    "fan": {
      "mediaId": "69517458637180",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.47,
        "bottomY": 0.71,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.25,
        "numberMaxWidthThree": 0.36
      }
    },
    "player": {
      "mediaId": "69517182796156",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.29,
        "numberY": 0.47,
        "bottomY": 0.71,
        "nameMaxWidth": 0.38,
        "numberHeight": 0.25,
        "numberMaxWidthThree": 0.36
      }
    }
  },
  "16116694909308": {
    "fan": {
      "mediaId": "69517445267836",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.287,
        "numberY": 0.48,
        "bottomY": 0.67,
        "nameMaxWidth": 0.36,
        "numberHeight": 0.25,
        "numberMaxWidthThree": 0.35
      }
    }
  },
  "16116688388476": {
    "fan": {
      "mediaId": "69517378683260",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.265,
        "numberY": 0.467,
        "bottomY": 0.67,
        "nameMaxWidth": 0.37,
        "numberHeight": 0.258,
        "numberMaxWidthThree": 0.35
      }
    }
  },
  "16114814452092": {
    "fan": {
      "mediaId": "69501912285564",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.268,
        "numberY": 0.475,
        "bottomY": 0.65,
        "nameMaxWidth": 0.365,
        "numberHeight": 0.25,
        "numberMaxWidthThree": 0.35
      }
    }
  },
  "16116696875388": {
    "fan": {
      "mediaId": "69517461029244",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.275,
        "numberY": 0.475,
        "bottomY": 0.665,
        "nameMaxWidth": 0.36,
        "numberHeight": 0.255,
        "numberMaxWidthThree": 0.35
      }
    }
  },
  "16116688683388": {
    "fan": {
      "mediaId": "69517379830140",
      "geometry": {
        "centerX": 0.5,
        "nameY": 0.268,
        "numberY": 0.472,
        "bottomY": 0.665,
        "nameMaxWidth": 0.365,
        "numberHeight": 0.257,
        "numberMaxWidthThree": 0.35
      }
    }
  }
};

  function normalize(value) {
    var text = String(value == null ? '' : value).toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/[’']/g, ' ').replace(/[_–—-]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function idOf(value) { return String(value == null ? '' : value).split('/').pop(); }
  function listOf(value) {
    if (Array.isArray(value)) return value.map(function (entry) {
      return entry && typeof entry === 'object' ? entry.title || entry.name || entry.value || '' : entry;
    });
    return value == null ? [] : String(value).split(',');
  }
  function tagsOf(product) { return listOf(product.tags).map(normalize).filter(Boolean); }
  function isPrintEligible(product) {
    product = product || {};
    var title = String(product.title || '');
    if (!/(?:^|[^\d])(?:26\s*[\/\-–]\s*27|2026\s*[\/\-–]\s*(?:20)?27)(?!\d)/i.test(title)) return false;
    if (!/(^|\W)(maillot|jersey|shirt|ensemble)(\W|$)/.test(normalize(title))) return false;
    var garment = normalize([title, product.handle].concat(listOf(product.tags)).join(' '));
    if (/(^|\W)(femme|femmes|woman|women|womens|female|girl|girls|lady|ladies|dame|dames|feminin|feminine)(\W|$)/.test(garment)) return false;
    return true;
  }
  function optionText(variant) {
    if (!variant) return '';
    return normalize([variant.title, variant.name, variant.option1, variant.option2, variant.option3].concat(listOf(variant.options)).join(' '));
  }
  // Exact reviewed identities only. The supplier calls its burgundy Fan away
  // shirt "Special"; its front and back match Monaco's official 26/27 away.
  function reviewedMonacoKit(product) {
    var identities = {
      '16116686127484': {handle:'maillot-monaco-y254096362',title:'maillot monaco edition speciale 26/27',kit:'away',kind:'fan'},
      '16116668170620': {handle:'maillot-monaco-y254100651',title:'maillot monaco exterieur player version 26/27',kit:'away',kind:'player'},
      '16116682817916': {handle:'maillot-monaco-y254097241',title:'maillot monaco third 26/27',kit:'third',kind:'fan'}
    };
    var entry = identities[idOf(product.productId || product.id)];
    return entry && product.handle === entry.handle && normalize(product.title) === entry.title && isShortSleeve(product) ? entry : null;
  }
  // Only these exact photographed 26/27 identities may acquire an official nameset.
  function reviewedAlbKit(product) {
    var identities = {
      '16116503642492':{handle:'maillot-arsenal-domicile-26-27',title:'maillot arsenal domicile 26/27',club:'arsenal',kit:'home'},
      '16116706378108':{handle:'maillot-arsenal-y239747653',title:'maillot arsenal domicile player version 26/27',club:'arsenal',kit:'home'},
      '16116503576956':{handle:'maillot-arsenal-exterieur-26-27',title:'maillot arsenal exterieur 26/27',club:'arsenal',kit:'away'},
      '16114814976380':{handle:'maillot-arsenal-third-26-27',title:'maillot arsenal third 26/27',club:'arsenal',kit:'third',kind:'fan'},
      '16116689895804':{handle:'maillot-liverpool-y254095473',title:'maillot liverpool exterieur 26/27',club:'liverpool',kit:'away'},
      '16116684423548':{handle:'maillot-liverpool-y254096892',title:'maillot liverpool third 26/27',club:'liverpool',kit:'third'},
      '16114814878076':{handle:'maillot-bayern-munich-domicile-26-27',title:'maillot bayern munich domicile 26/27',club:'bayern',kit:'home',kind:'fan'},
      '16116696482172':{handle:'maillot-bayern-munich-y254094268',title:'maillot bayern munich exterieur 26/27',club:'bayern',kit:'away'},
      '16116686946684':{handle:'maillot-bayern-munich-y254096203',title:'maillot bayern munich third 26/27',club:'bayern',kit:'third',kind:'fan'}
    };
    var entry = identities[idOf(product.productId || product.id)];
    return entry && product.handle === entry.handle && normalize(product.title) === entry.title && isShortSleeve(product) ? entry : null;
  }
  function variantKind(product, variant) {
    var text = optionText(variant);
    var versionIndex = Number(product.versionIndex);
    if (product.versionIndex != null && variant && Array.isArray(variant.options) && Number.isInteger(versionIndex) && versionIndex >= 0) {
      var option = variant.options[versionIndex];
      if (option && typeof option === 'object') option = option.value;
      text = normalize(option || text);
    }
    if (/(^|\W)(player|joueur|pro|authentic)(\W|$)/.test(text)) return 'player';
    if (/(^|\W)(fan|supporter|standard|replica)(\W|$)/.test(text)) return 'fan';
    text = normalize(product.title);
    if (/(^|\W)(player|joueur|pro|authentic)(\W|$)/.test(text)) return 'player';
    if (/(^|\W)(fan|supporter|standard|replica)(\W|$)/.test(text)) return 'fan';
    var monaco = reviewedMonacoKit(product);
    if (monaco && monaco.kind === 'fan' && /^(xs|s|m|l|xl|xxl|2xl|3xl|4xl)$/.test(optionText(variant))) return 'fan';
    var alb = reviewedAlbKit(product);
    if (alb && alb.kind === 'fan' && /^(xs|s|m|l|xl|xxl|2xl|3xl|4xl)$/.test(optionText(variant))) return 'fan';
    if (idOf(product.productId || product.id) === '16116698153340' &&
        product.handle === 'maillot-monaco-y254093970' &&
        text === 'maillot monaco domicile 26/27' &&
        /^(xs|s|m|l|xl|xxl|2xl|3xl|4xl)$/.test(optionText(variant))) return 'fan';
    return 'default';
  }
  function seasonOf(product) {
    // Only the customer-facing title can establish a season: handles and tags can be stale.
    var input = String(product.title || '');
    var match = input.match(/\b((?:19|20)\d{2})\s*[\/\-–]\s*((?:19|20)?\d{2})\b/);
    var start;
    var end;
    if (match) {
      start = Number(match[1]);
      end = Number(match[2]);
      if (end < 100) end += Math.floor(start / 100) * 100;
      if (end < start && match[2].length === 2) end += 100;
      if (end === start + 1) return { start: start, end: end, label: start + '/' + String(end).slice(-2) };
    }
    match = input.match(/\b(\d{2})\s*[\/\-–]\s*(\d{2})\b/);
    if (match) {
      start = Number(match[1]);
      end = Number(match[2]);
      start += start >= 50 ? 1900 : 2000;
      end += Math.floor(start / 100) * 100;
      if (end < start) end += 100;
      if (end === start + 1) return { start: start, end: end, label: start + '/' + String(end).slice(-2) };
    }
    match = input.match(/\b((?:19|20)\d{2})\b/);
    return match ? { start: Number(match[1]), end: null, label: match[1] } : null;
  }
  function exactLeagueTag(tags) {
    var aliases = {
      'ligue 1': 'ligue-1', 'ligue1': 'ligue-1', 'l1': 'ligue-1', 'ligue 1 mcdonalds': 'ligue-1',
      'premier league': 'premier-league', 'epl': 'premier-league', 'english premier league': 'premier-league',
      'laliga': 'la-liga', 'la liga': 'la-liga', 'liga espagnole': 'la-liga',
      'serie a': 'serie-a', 'seriea': 'serie-a', 'bundesliga': 'bundesliga', '1 bundesliga': 'bundesliga'
    };
    for (var i = 0; i < tags.length; i += 1) {
      var cleaned = tags[i].replace(/^(?:league|ligue|championnat|competition)\s*:\s*/, '');
      if (aliases[cleaned]) return aliases[cleaned];
    }
    return null;
  }
  function categoryOf(product, tags) {
    var title = normalize(product.title + ' ' + (product.handle || ''));
    var category = normalize([product.type, product.product_type, product.category].concat(tags).join(' '));
    var all = title + ' ' + category;
    if (/(^|\W)(concept|concepts|fantasy|fantaisie|manga|anime)(\W|$)/.test(all)) return 'concept';
    if (/(^|\W)(retro|retros|vintage|retrospective|historique)(\W|$)/.test(all)) return 'retro';
    if (/(^|\W)(nation|nations|national|nationales|nationaux|selection|selections|pays|world cup|coupe du monde|cdm)(\W|$)/.test(category)) return 'nation';
    // A country name in a club's tags is not enough to turn a club shirt into a national shirt.
    if (/(^|\W)(france|bresil|brazil|argentine|argentina|espagne|spain|portugal|maroc|morocco|algerie|algeria|japon|japan|angleterre|england|allemagne|germany|italie|italy|belgique|belgium|pays bas|netherlands|croatie|croatia|mexique|mexico|senegal|tunisie|tunisia|cameroun|cameroon|cote d ivoire|ivory coast|nigeria|ghana|uruguay|colombie|colombia|chili|chile|perou|peru|etats unis|usa|canada|coree du sud|south korea|arabie saoudite|saudi arabia|australie|australia|nouvelle zelande|new zealand|suisse|switzerland|autriche|austria|danemark|denmark|suede|sweden|norvege|norway|ecosse|scotland|pays de galles|wales|irlande|ireland|pologne|poland|ukraine|turquie|turkey|serbie|serbia|grece|greece|hongrie|hungary|roumanie|romania|slovenie|slovenia|slovaquie|slovakia|tchequie|czech republic)(\W|$)/.test(title)) return 'nation';
    return null;
  }
  function clubLeague(product) {
    var text = normalize([product.title, product.handle, product.club].join(' '));
    if (/(^|\W)(marseille|olympique de marseille|psg|paris saint germain|paris sg|paris fc|olympique lyonnais|lyon|lille|lens|monaco|rennes|nice|nantes|strasbourg|brest|toulouse|montpellier|auxerre|angers|lorient|le havre|troyes|le mans)(\W|$)/.test(text)) return 'ligue-1';
    if (/(^|\W)(arsenal|chelsea|liverpool|manchester city|manchester united|tottenham|newcastle|aston villa|west ham|everton|brighton|crystal palace|fulham|brentford|bournemouth|nottingham forest|wolverhampton)(\W|$)/.test(text)) return 'premier-league';
    if (/(^|\W)(real madrid|barcelona|barcelone|barca|atletico madrid|atletico de madrid|athletic bilbao|athletic club|real sociedad|real betis|villarreal|sevilla|seville|valencia|valence|girona|celta vigo|osasuna|getafe|espanyol|rayo vallecano)(\W|$)/.test(text)) return 'la-liga';
    if (/(^|\W)(juventus|inter milan|internazionale|inter de milan|ac milan|milan ac|as roma|roma|napoli|naples|lazio|atalanta|fiorentina|bologna|bologne|torino|udinese|genoa|parma|parme|cagliari|lecce|sassuolo)(\W|$)/.test(text)) return 'serie-a';
    if (/(^|\W)(bayern|borussia dortmund|dortmund|borussia monchengladbach|monchengladbach|bayer leverkusen|leverkusen|rb leipzig|leipzig|eintracht frankfurt|francfort|wolfsburg|stuttgart|freiburg|fribourg|werder bremen|werder breme|hoffenheim|augsburg|mainz|mayence|union berlin)(\W|$)/.test(text)) return 'bundesliga';
    return null;
  }
  function referencePhoto(product, variant) {
    var id = idOf(product.productId || product.id);
    var verified = verifiedPhotos[id];
    var registered = gridPhotos[id];
    var kind = variantKind(product, variant);
    // These are separate Player products whose only variant option is size.
    // Their single verified back is filed as default, even though the title says Player.
    if (['16116667515260', '16116667482492', '16116320862588', '16116671152508', '16116669350268', '16116668858748', '16116667613564'].indexOf(id) !== -1 && verified && verified.default) return verified.default;
    // A newly reviewed Fan back must never mask an existing Player back in
    // the grid registry (or the reverse).
    return (verified && verified[kind]) || (registered && registered[kind]) ||
      (kind === 'default' && ((verified && verified.default) || (registered && registered.default))) || null;
  }
  var gridPhotos = Object.create(null);
  function registerGrid(data) {
    var entries = data && data.products;
    if (!entries || typeof entries !== 'object') return;
    Object.keys(entries).forEach(function (id) {
      if (!/^\d+$/.test(id) || !entries[id] || typeof entries[id] !== 'object') return;
      var accepted = Object.create(null);
      ['fan', 'player', 'default'].forEach(function (kind) {
        var photo = entries[id][kind];
        if (photo && /^\d+$/.test(idOf(photo.mediaId)) && photo.geometry) accepted[kind] = photo;
      });
      gridPhotos[id] = accepted;
    });
  }
  function referenceTypography(product, profile) {
    var monaco = reviewedMonacoKit(product);
    if (monaco && profile.season && profile.season.start === 2026) {
      return {verifiedFont:true, fontWeight:400, numberFontWeight:400, strokeWidth:0,
        fontFamily:'FDPrintMonacoLeague2627', nameFontFamily:'FDPrintMonacoLeague2627', numberFontFamily:'FDPrintMonacoLeague2627',
        ink:monaco.kit === 'away' ? '#eac896' : '#000000', inkSource:'reference', nameSize:0.052, nameTracking:0,
        referenceLabel:'Monaco · ' + (monaco.kit === 'away' ? 'Extérieur' : 'Third') + ' 26/27 · Ligue 1'};
    }
    if (['concept', 'retro'].indexOf(profile.id) !== -1 || !profile.season) return {};
    // These two generically titled supplier products are visually different
    // from the official 26/27 home shirts despite their "Paire:Domicile" tags.
    if (['maillot-psg-player-version-26-27', 'maillot-marseille-player-version-26-27'].indexOf(String(product.handle || '')) !== -1) return {};
    // Handles can be stale (a PSG product in this catalog still has a Barca handle).
    // A present title is the identity source; never borrow another club from its handle.
    var title = normalize(product.title || product.handle || '');
    // These references describe shirt backs, not shorts, sleeveless tops or complete outfits.
    if (!/(^|\W)(maillot|jersey|shirt)(\W|$)/.test(title)) return {};
    var garment = normalize([title, product.type, product.productType, product.product_type].concat(listOf(product.tags)).join(' '));
    if (/(^|\W)(entrainement|training|trainings|pre match|prematch|warm up|echauffement|survetement|tracksuit|veste|jacket|hoodie|polo|t shirt|tshirt|anti|concept|fantasy|fiction|fictif|fictive|richmond|ted lasso|gardien|goalkeeper|gk)(\W|$)/.test(garment)) return {};
    // Editions and collaborations can carry a different competition nameset;
    // no standard club profile is assigned without a source for that shirt.
    if (/(^|\W)(fourth|quatrieme|special|speciale|collab|collaboration|legends|stray kids|ed sheeran|play)(\W|$)/.test(title)) return {};
    var year = profile.season.start;
    var away = /(^|\W)(exterieur|away|rext)(\W|$)/.test(title);
    var home = /(^|\W)(domicile|home)(\W|$)/.test(title);
    var third = /(^|\W)(third|troisieme)(\W|$)/.test(title);
    if (profile.id === 'nation' && /(^|\W)france(\W|$)/.test(title) && year === 2026 && home) {
      // The official home name font explicitly forbids embedding; retain a clearly indicative preview.
      return { verifiedFont: false, referenceLabel: 'France · Domicile 2026', ink: '#ffffff', inkSource: 'reference', strokeColor: '#b28163', strokeWidth: 0.0015 };
    }
    var result = { verifiedFont: true, fontWeight: 400, numberFontWeight: 400, strokeWidth: 0, nameTracking: 0.0015 };
    if (/\bmonaco\b/.test(title) && year === 2026 && home &&
        product.handle === 'maillot-monaco-y254093970' &&
        idOf(product.productId || product.id) === '16116698153340') {
      result.fontFamily = 'FDPrintMonacoHomeLeague2627';
      result.nameFontFamily = 'FDPrintMonacoHomeLeague2627';
      result.numberFontFamily = 'FDPrintMonacoHomeLeague2627';
      result.ink = '#b31a38';
      result.inkSource = 'reference';
      result.nameSize = 0.052;
      result.nameTracking = 0;
      result.referenceLabel = 'Monaco · Domicile 26/27 · Ligue 1';
      return result;
    }
    if (/\bpsg\b/.test(title) && year === 2026 && home &&
        product.handle === 'maillot-psg-domicile-26-27' &&
        idOf(product.productId || product.id) === '16116161053052') {
      result.fontFamily = 'FDPrintPSGHomeLeague2627Fill';
      result.nameFontFamily = 'FDPrintPSGHomeLeague2627Fill';
      result.nameFontLayers = [
        { family: 'FDPrintPSGHomeLeague2627Stroke', color: '#b92030' },
        { family: 'FDPrintPSGHomeLeague2627Fill', color: '#ffffff' }
      ];
      result.glyphSet = 'psg-home-ligue1-2627';
      result.glyphPreserveColor = true;
      result.ink = '#ffffff';
      result.inkSource = 'reference';
      result.nameSize = 0.052;
      result.referenceLabel = 'PSG · Domicile 26/27 · Ligue 1';
      return result;
    }
    if (/\bpsg\b/.test(title) && year === 2026 && away &&
        product.handle === 'maillot-psg-y254095704' &&
        idOf(product.productId || product.id) === '16116688683388') {
      result.fontFamily = 'FDPrintPSGAwayLeague2627';
      result.nameFontFamily = 'FDPrintPSGAwayLeague2627';
      result.glyphSet = 'psg-away-ligue1-2627';
      result.glyphPreserveColor = true;
      result.ink = '#232e41';
      result.inkSource = 'reference';
      result.nameSize = 0.052;
      result.referenceLabel = 'PSG · Extérieur 26/27 · Ligue 1';
      return result;
    }
    if (profile.id === 'nation' && /(^|\W)(angleterre|england)(\W|$)/.test(title) && (home || away)) {
      // These five backs were visually matched to Nike England 2026. The number
      // sprites are original, while the actual name alphabet was unavailable.
      var englandVerifiedHandles = home
        ? ['maillot-england-sleeves-t-domicile-manches-longues-2026', 'maillot-england-t-domicile-25-26', 'maillot-england-wolrd-domicile-player-version-25-26']
        : ['maillot-angleterre-exterieur-femme-coupe-du-monde-2026', 'maillot-angleterre-y239748976'];
      if (englandVerifiedHandles.indexOf(String(product.handle || '')) === -1) return {};
      result.season = { start: 2026, end: null, label: '2026' };
      result.referenceIncomplete = true;
      result.glyphSet = 'england-' + (home ? 'home' : 'away') + '-2026-numerals';
      result.glyphPreserveColor = true;
      result.fontFamily = BASE.fontFamily;
      result.nameFontFamily = BASE.nameFontFamily;
      result.fontWeight = 600;
      result.nameTracking = 0.004;
      result.referenceLabel = 'Angleterre · ' + (home ? 'Domicile' : 'Extérieur') + ' 2026 · chiffres de référence';
      result.ink = home ? '#be2c3c' : '#ffffff';
      result.inkSource = 'reference';
      return result;
    }
    if (profile.id === 'nation' && /(^|\W)france(\W|$)/.test(title) && year === 2026 && away) {
      result.fontFamily = 'FDPrintFranceAway2026';
      result.numberFontFamily = 'FDPrintFranceAway2026';
      result.glyphSet = 'france-away-2026';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'France · Extérieur 2026';
      result.ink = '#ad6d38';
      result.inkSource = 'reference';
      result.nameSize = 0.052;
      return result;
    }
    if (/marseille/.test(title) && year === 2026 && (home || away || third)) {
      result.glyphSet = 'om-ligue1-2627-' + (away ? 'white' : third ? 'black' : 'blue');
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Marseille · Ligue 1';
      result.nameSize = 0.046;
      return result;
    }
    if (/marseille/.test(title) && year === 2025 && home) {
      result.glyphSet = 'om-ligue1-2526-blue';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Marseille · Ligue 1';
      result.nameSize = 0.046;
      return result;
    }
    if (/atletico madrid/.test(title) && year === 2026 && profile.season.end === 2027 && home && profile.id === 'la-liga' && String(product.handle || '') === 'maillot-atletico-madrid-y254095415') {
      // LFP is the LaLiga choice on the club's own 26/27 configurator; the
      // MET/European face is different and is not assumed for this product.
      result.glyphSet = 'atleti-home-laliga-2627-numerals';
      result.nameFontFamily = 'FDPrintAtletiLFP';
      result.numberFontFamily = 'FDPrintAtletiLFP';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Atlético Madrid · Domicile LaLiga 26/27';
      result.ink = '#ffffff';
      result.inkSource = 'reference';
      result.strokeColor = '#17191d';
      result.strokeWidth = 0.001;
      result.nameSize = 0.054;
      return result;
    }
    if (/atletico madrid/.test(title) && year === 2026 && profile.season.end === 2027 && profile.id === 'la-liga' &&
      (away && String(product.handle || '') === 'maillot-atletico-madrid-exterieur-player-version-26-27' ||
       third && String(product.handle || '') === 'maillot-atletico-madrid-y254097403')) {
      result.glyphSet = away ? 'atleti-away-lfp-2627-numerals' : 'atleti-third-lfp-2627-numerals';
      result.nameFontFamily = 'FDPrintAtletiLFP';
      result.numberFontFamily = 'FDPrintAtletiLFP';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Atlético Madrid · ' + (away ? 'Extérieur' : 'Third') + ' LaLiga 26/27';
      result.ink = away ? '#ecf700' : '#003594';
      result.inkSource = 'reference';
      result.strokeColor = away ? '#111111' : '#ffffff';
      result.strokeWidth = 0.001;
      result.nameSize = 0.054;
      return result;
    }
    // Club competition kits can use another font (Kobe away, retro third).
    // Without a league selection, the sourced FCBLaLiga face is confined to home.
    if (/(barcelone|barcelona|barca)/.test(title) && year >= 2025 && year <= 2026 && home) {
      // 26/27 switched to Modernista Home; FCBLaLiga is the older nameset.
      var barcaHomeHandles = ['maillot-fc-barcelone-domicile-player-version-26-27', 'maillot-fc-barcelone-y254093765'];
      if (year === 2026 && barcaHomeHandles.indexOf(String(product.handle || '')) === -1) return {};
      result.fontFamily = year === 2026 ? 'FDPrintBarcaModernista2627' : 'FDPrintBarcaLiga';
      result.numberFontFamily = result.fontFamily;
      result.referenceLabel = year === 2026 ? 'Barça · Domicile LaLiga 26/27' : 'Barça · LaLiga 25/26';
      result.nameSize = 0.052;
      if (year === 2026 && home) {
        result.ink = '#fab936';
        result.inkSource = 'reference';
        result.strokeColor = '#ae730f';
        result.strokeWidth = 0.001;
      }
      return result;
    }
    if (/(barcelone|barcelona|barca)/.test(title) && year === 2026 && profile.season.end === 2027 && (away || third)) {
      // The club's 26/27 configurator offers its Kobe away and retro third
      // namesets for the UCL. These are never labelled as the LaLiga print.
      var barcaCompetitionHandles = away
        ? ['maillot-fc-barcelone-exterieur-26-27', 'maillot-fc-barcelone-exterieur-manches-longues-26-27']
        : ['maillot-fc-barcelone-third-26-27', 'maillot-fc-barcelone-third-manches-longues-26-27'];
      if (barcaCompetitionHandles.indexOf(String(product.handle || '')) === -1) return {};
      result.fontFamily = away ? 'FDPrintBarcaKobe2627' : 'FDPrintBarcaNikeThird2627';
      result.numberFontFamily = result.fontFamily;
      result.referenceLabel = 'Barça · ' + (away ? 'Extérieur' : 'Third') + ' UCL 26/27';
      result.ink = away ? '#d4b560' : '#293150';
      result.inkSource = 'reference';
      result.strokeColor = away ? '#967a2c' : '#7a1e2a';
      result.strokeWidth = away ? 0.0009 : 0.0011;
      result.numberStrokeWidth = away ? 0.0018 : 0.003;
      result.numberDotsColor = away ? '#20202c' : '#03b8af';
      result.numberDieCut = true;
      result.numberJoinStyle = away ? 'miter' : 'round';
      result.numberTracking = -0.012;
      result.nameSize = 0.046;
      result.nameTracking = away ? -0.0016 : -0.0008;
      return result;
    }
    if (/real madrid/.test(title) && year === 2026 && (home || away || third)) {
      var madridKit = home ? 'home' : away ? 'away' : 'third';
      var madridVerifiedHandles = {
        home: ['maillot-real-madrid-domicile-26-27', 'maillot-real-madrid-domicile-manches-longues-26-27', 'maillot-real-madrid-y231764780'],
        away: ['maillot-real-madrid-y254096406', 'maillot-real-madrid-y254094935'],
        third: ['maillot-real-madrid-third-26-27', 'maillot-real-madrid-y254100526', 'maillot-real-madrid-y254093690']
      };
      if (madridVerifiedHandles[madridKit].indexOf(String(product.handle || '')) === -1) return {};
      result.fontFamily = 'FDPrintReal2627';
      result.numberFontFamily = 'FDPrintReal2627';
      result.glyphSet = 'real-' + madridKit + '-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Real Madrid · ' + (home ? 'Domicile' : away ? 'Extérieur' : 'Third') + ' 26/27';
      result.ink = home ? '#143933' : '#f4f0da';
      result.inkSource = 'reference';
      result.nameSize = 0.055;
      return result;
    }
    if (/(^|\W)inter milan(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && (away || third)) {
      // Only these three photographed match shirts have a confirmed official Inter nameset.
      var interVerifiedHandles = away
        ? ['maillot-inter-milan-y254099556', 'maillot-inter-milan-y254096010']
        : ['maillot-inter-milan-y254097232'];
      var interStandalone = away ? { handle: 'maillot-inter-milan-y254099571', id: '16116671152508' } : { handle: 'maillot-inter-milan-y254100183', id: '16116669350268' };
      if (interVerifiedHandles.indexOf(String(product.handle || '')) === -1 && !(String(product.handle || '') === interStandalone.handle && idOf(product.productId || product.id) === interStandalone.id)) return {};
      result.glyphSet = away ? 'inter-away-2627' : 'inter-third-seriea-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = away ? 'Inter Milan · Extérieur 26/27' : 'Inter Milan · Third Serie A 26/27';
      result.ink = away ? '#221f39' : '#fad945';
      result.inkSource = 'reference';
      result.nameSize = 0.064;
      result.nameTracking = 0.006;
      return result;
    }
    if (/(^|\W)inter milan(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && home && (String(product.handle || '') === 'maillot-inter-milan-y254093350' || (String(product.handle || '') === 'maillot-inter-milan-domicile-player-version-26-27' && idOf(product.productId || product.id) === '16116320862588'))) {
      result.glyphSet = 'inter-home-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Inter Milan · Domicile Serie A 26/27';
      result.ink = '#ffb71b';
      result.inkSource = 'reference';
      result.nameSize = 0.061;
      result.nameTracking = 0.006;
      return result;
    }
    if (/(^|\W)(naples|napoli)(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && (home || away)) {
      var napoliVerifiedHandles = home ? ['maillot-naples-y254095366'] : ['maillot-naples-y254094426'];
      var napoliPlayer = home
        ? { handle: 'maillot-naples-y254100844', id: '16116667515260' }
        : { handle: 'maillot-naples-y254100841', id: '16116667482492' };
      var standalonePlayer = String(product.handle || '') === napoliPlayer.handle && idOf(product.productId || product.id) === napoliPlayer.id;
      if (napoliVerifiedHandles.indexOf(String(product.handle || '')) === -1 && !standalonePlayer) return {};
      result.glyphSet = 'napoli-' + (home ? 'home' : 'away') + '-seriea-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Naples · ' + (home ? 'Domicile' : 'Extérieur') + ' Serie A 26/27';
      result.nameSize = 0.055;
      result.bottomTextSupported = false;
      return result;
    }
    if (/(^|\W)ac milan(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && home && profile.id === 'serie-a' && String(product.handle || '') === 'maillot-ac-milan-y254096147') {
      // All 36 source glyphs match the official active 26/27 home nameset.
      result.glyphSet = 'acmilan-home-seriea-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'AC Milan · Domicile Serie A 26/27';
      result.nameSize = 0.055;
      return result;
    }
    if (/(^|\W)ac milan(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && away && profile.id === 'serie-a' && String(product.handle || '') === 'maillot-ac-milan-exterieur-26-27') {
      result.glyphSet = 'acmilan-away-seriea-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'AC Milan · Extérieur Serie A 26/27';
      result.nameSize = 0.055;
      return result;
    }
    if (/(^|\W)ac milan(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && third && profile.id === 'serie-a' && String(product.handle || '') === 'maillot-ac-milan-third-26-27') {
      result.glyphSet = 'acmilan-third-seriea-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'AC Milan · Third Serie A 26/27';
      result.nameSize = 0.055;
      return result;
    }
    if (/(^|\W)juventus(\W|$)/.test(title) && year === 2026 && profile.season.end === 2027 && (home || away || third) && !/(^|\W)(edition speciale|special edition)(\W|$)/.test(title)) {
      var juventusKit = away ? 'away' : third ? 'third' : 'home';
      // Catalog title alone is insufficient: the white zigzag shirt called Third
      // does not match the official black 26/27 third nameset.
      var juventusVerifiedHandles = {
        home: ['maillot-juventus-y254099074'],
        away: ['maillot-juventus-y254094960'],
        third: ['maillot-juventus-y254096968']
      };
      var juventusStandalone = away ? { handle: 'maillot-juventus-y254100433', id: '16116668858748' } : third ? { handle: 'maillot-juventus-y254100800', id: '16116667613564' } : null;
      var juventusFanHome = home && title === 'maillot juventus domicile 26/27' &&
        product.handle === 'maillot-juventus-y254093370' && idOf(product.productId || product.id) === '16116700545404' && isShortSleeve(product);
      if (!juventusFanHome && juventusVerifiedHandles[juventusKit].indexOf(String(product.handle || '')) === -1 && !(juventusStandalone && String(product.handle || '') === juventusStandalone.handle && idOf(product.productId || product.id) === juventusStandalone.id)) return {};
      result.glyphSet = 'juventus-' + juventusKit + '-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Juventus · ' + (away ? 'Extérieur' : third ? 'Third' : 'Domicile') + ' 26/27';
      result.nameSize = 0.078;
      result.numberTracking = 0.007;
      result.nameTracking = 0;
      return result;
    }
    var alb = reviewedAlbKit(product);
    if (alb && alb.club === 'bayern' && year === 2026 && profile.season.end === 2027) {
      result.glyphSet = 'bayern-' + alb.kit + '-2627';
      result.glyphPreserveColor = true;
      result.referenceLabel = 'Bayern · ' + (alb.kit === 'home' ? 'Domicile' : alb.kit === 'away' ? 'Extérieur' : 'Third') + ' 26/27';
      result.ink = alb.kit === 'home' ? '#ffffff' : alb.kit === 'away' ? '#161e36' : '#ff1f3d';
      result.inkSource = 'reference';
      result.nameTracking = 0.004;
      result.numberTracking = 0.008;
      result.nameSize = 0.05;
      // The home back already carries FC BAYERN. The away shirt receives it with the nameset.
      if (alb.kit === 'away') result.fixedTopText = 'FC BAYERN';
      return result;
    }
    if (profile.id === 'premier-league' && year >= 2023 && year <= 2026) {
      // An ambiguous supplier title does not identify a home/away/third kit.
      if (!(home || away || third)) return {};
      // Club membership is seasonal. A supplier's "Premier League" tag alone is not evidence.
      // Primary source lists, verified 2026-09-23: research/premier-league-membership.json.
      var membersByYear = {
        2023: 'arsenal,aston-villa,bournemouth,brentford,brighton,burnley,chelsea,crystal-palace,everton,fulham,liverpool,luton,manchester-city,manchester-united,newcastle,nottingham-forest,sheffield-united,tottenham,west-ham,wolves',
        2024: 'arsenal,aston-villa,bournemouth,brentford,brighton,chelsea,crystal-palace,everton,fulham,ipswich,leicester,liverpool,manchester-city,manchester-united,newcastle,nottingham-forest,southampton,tottenham,west-ham,wolves',
        2025: 'arsenal,aston-villa,bournemouth,brentford,brighton,burnley,chelsea,crystal-palace,everton,fulham,leeds,liverpool,manchester-city,manchester-united,newcastle,nottingham-forest,sunderland,tottenham,west-ham,wolves',
        2026: 'arsenal,aston-villa,bournemouth,brentford,brighton,chelsea,coventry,crystal-palace,everton,fulham,hull,ipswich,leeds,liverpool,manchester-city,manchester-united,newcastle,nottingham-forest,sunderland,tottenham'
      };
      var aliases = {
        arsenal: 'arsenal', 'aston-villa': 'aston villa', bournemouth: '(?:afc )?bournemouth', brentford: 'brentford', brighton: 'brighton(?: (?:and|&) hove albion)?',
        burnley: 'burnley', chelsea: 'chelsea', coventry: 'coventry(?: city)?', 'crystal-palace': 'crystal palace', everton: 'everton', fulham: 'fulham',
        hull: 'hull(?: city)?', ipswich: 'ipswich(?: town)?', leeds: 'leeds(?: united)?', leicester: 'leicester(?: city)?', liverpool: 'liverpool', luton: 'luton(?: town)?',
        'manchester-city': '(?:manchester|man) city', 'manchester-united': '(?:manchester|man) (?:united|utd)', newcastle: 'newcastle(?: united)?',
        'nottingham-forest': '(?:nottingham|nott m) forest', 'sheffield-united': '(?:sheffield|sheff) (?:united|utd)', southampton: 'southampton',
        sunderland: 'sunderland', tottenham: 'tottenham(?: hotspur)?|spurs', 'west-ham': 'west ham(?: united)?', wolves: 'wolverhampton(?: wanderers)?|wolves'
      };
      if (profile.season.end !== year + 1) return {};
      if (/(^|\W)(a league|championship|league one|league two|efl|wsl|scottish|spfl|sarandi|tula|montevideo|newcastle jets)(\W|$)/.test(garment)) return {};
      var matchingClubs = Object.keys(aliases).filter(function (club) {
        return new RegExp('(^|\\W)(?:' + aliases[club] + ')(\\W|$)').test(title);
      });
      if (matchingClubs.length !== 1 || membersByYear[year].split(',').indexOf(matchingClubs[0]) === -1) return {};
      result.fontFamily = 'FDPrintPremierName';
      result.numberFontFamily = 'FDPrintPremierNumber';
      result.referenceLabel = 'Premier League';
      result.colorFonts = {
        light: { nameFamily: 'FDPrintPremierName', numberFamily: 'FDPrintPremierNumber' },
        dark: { nameFamily: 'FDPrintPremierNameNavy', numberFamily: 'FDPrintPremierNumberNavy' }
      };
      result.nameTracking = 0;
      result.nameCurve = 0.015;
      result.nameSize = 0.058;
      if (year === 2026 && ['maillot-manchester-city-domicile-26-27', 'maillot-manchester-city-domicile-manches-longues-26-27'].indexOf(String(product.handle || '')) !== -1) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      } else if (year === 2026 && String(product.handle || '') === 'maillot-manchester-city-y254095617' && away &&
        idOf(product.productId || product.id) === '16116689273212' && title === 'maillot manchester city exterieur 26/27' && isShortSleeve(product)) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
        result.referenceLabel = 'Manchester City · Extérieur 26/27 · Premier League';
      } else if (year === 2026 && String(product.handle || '') === 'maillot-manchester-city-y254094914') {
        result.ink = '#1d1f4d'; result.inkSource = 'reference';
      } else if (year === 2026 && String(product.handle || '') === 'maillot-chelsea-exterieur-26-27' && away) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      } else if (year === 2026 && String(product.handle || '') === 'maillot-chelsea-domicile-26-27' && home) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      } else if (year === 2026 && String(product.handle || '') === 'maillot-chelsea-y254094587' && third) {
        // The kit and its back match; the official PL nameset color is unconfirmed.
        return {};
      } else if (year === 2026 && ['maillot-liverpool-y254096496', 'maillot-liverpool-y254093376'].indexOf(String(product.handle || '')) !== -1 && home) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      } else if (year === 2026 && alb && alb.club === 'arsenal') {
        result.ink = alb.kit === 'third' ? '#1d1f4d' : '#ffffff'; result.inkSource = 'reference';
        result.referenceLabel = 'Arsenal · ' + (alb.kit === 'home' ? 'Domicile' : alb.kit === 'away' ? 'Extérieur' : 'Third') + ' 26/27 · Premier League';
      } else if (year === 2026 && alb && alb.club === 'liverpool') {
        result.ink = alb.kit === 'away' ? '#000000' : '#ffffff'; result.inkSource = 'reference';
        result.referenceLabel = 'Liverpool · ' + (alb.kit === 'away' ? 'Extérieur' : 'Third') + ' 26/27 · Premier League';
        if (alb.kit === 'away') {
          result.fontFamily = result.nameFontFamily = 'FDPrintPremierNameBlack';
          result.numberFontFamily = 'FDPrintPremierNumberBlack';
          result.colorFonts = {
            light:{nameFamily:'FDPrintPremierNameBlack',numberFamily:'FDPrintPremierNumberBlack'},
            dark:{nameFamily:'FDPrintPremierNameBlack',numberFamily:'FDPrintPremierNumberBlack'}
          };
        }
      } else if (year === 2026 && String(product.handle || '') === 'maillot-manchester-united-y239747695' && home) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      } else if (year === 2026 && ['maillot-manchester-united-exterieur-manches-longues-26-27', 'maillot-manchester-united-y254094879'].indexOf(String(product.handle || '')) !== -1 && away) {
        result.ink = '#ffffff'; result.inkSource = 'reference';
      }
      // White or navy chosen from shirt brightness is not evidence of the
      // club's actual 26/27 Premier League print. Keep its back photo visible,
      // but withhold the simulated lettering until the exact ink is sourced.
      if (year === 2026 && result.inkSource !== 'reference') return {};
      return result;
    }
    if (profile.id === 'nation' && /(^|\W)(espagne|spain)(\W|$)/.test(title) && year === 2026 && home &&
      ['maillot-espagne-domicile-coupe-du-monde-2026','maillot-espagne-domicile-femme-coupe-du-monde-2026'].indexOf(String(product.handle || '')) !== -1) {
      // Standard RFEF printed backs are gold with an outline and miniature crests.
      // Pilares Final has similar shapes but lacks those details: use it as a
      // visually informed, explicitly indicative approximation only.
      return { verifiedFont: false, indicativeReferenceFont: true,
        fontFamily: 'FDPrintSpain2026, "Arial Narrow", Arial, sans-serif', nameFontFamily: 'FDPrintSpain2026, "Arial Narrow", Arial, sans-serif', numberFontFamily: 'FDPrintSpain2026, "Arial Narrow", Arial, sans-serif',
        referenceLabel: 'Espagne · Domicile 2026 · simulation', ink: '#f8a701', inkSource: 'calibrated',
        strokeColor: '#9a640f', strokeWidth: 0.001, nameSize: 0.052 };
    }
    if (profile.id === 'nation' && /(^|\W)portugal(\W|$)/.test(title) && year === 2026 && (home || away)) {
      result.fontFamily = 'FDPrintPortugal2026';
      result.numberFontFamily = 'FDPrintPortugal2026';
      result.referenceLabel = 'Portugal · ' + (home ? 'Domicile' : 'Extérieur') + ' 2026';
      result.ink = home ? '#ffffff' : '#553038';
      result.inkSource = 'reference';
      result.nameSize = 0.052;
      return result;
    }
    return {};
  }
  function inkOf(product, variant) {
    var reference = referencePhoto(product, variant);
    if (reference && reference.ink) return { ink: reference.ink, inkSource: reference.inkVerified ? 'reference' : 'calibrated', inkVerified: !!reference.inkVerified, strokeWidth: 0 };
    var explicit = product.printColor || product.print_color || product.flocageColor || product.flocage_color;
    var tags = tagsOf(product);
    if (!explicit) {
      tags.some(function (tag) {
        var match = tag.match(/^(?:print color|flocage color|couleur flocage|flocage)\s*:\s*(.+)$/);
        if (match) { explicit = match[1]; return true; }
        return false;
      });
    }
    var colors = { blanc: '#ffffff', white: '#ffffff', noir: '#111318', black: '#111318', or: '#d7b66a', gold: '#d7b66a', jaune: '#f4d44b', yellow: '#f4d44b', rouge: '#d52732', red: '#d52732', bleu: '#1957a6', blue: '#1957a6', rose: '#f27ea7', pink: '#f27ea7' };
    var color = normalize(explicit);
    if (/^#[\da-f]{6}$/.test(color) || /^#[\da-f]{3}$/.test(color)) return { ink: color, inkSource: 'explicit', strokeWidth: 0 };
    if (colors[color]) return { ink: colors[color], inkSource: 'explicit', strokeWidth: 0 };
    // The renderer samples the actual back photograph when there is no confirmed ink color.
    return { ink: '#ffffff', inkSource: 'contrast', strokeWidth: 0.001 };
  }
  function resolve(product, variant) {
    product = product || {};
    var tags = tagsOf(product);
    var category = categoryOf(product, tags);
    var explicitLeague = exactLeagueTag(tags);
    var detectedClub = clubLeague(product);
    var key = category || explicitLeague || detectedClub || 'neutral';
    var season = seasonOf(product);
    var title = normalize(product.title || '');
    if (!category && season && season.start === 2026) {
      // A stale league tag is not enough to make a relegated side a 26/27 Ligue 1 or PL team.
      var ligueOneClubs = /(^|\W)(psg|paris saint germain|paris sg|paris fc|marseille|monaco|lyon|lille|lens|rennes|nice|toulouse|strasbourg|brest|auxerre|angers|lorient|le havre|troyes|le mans)(\W|$)/;
      if (key === 'ligue-1' && !ligueOneClubs.test(title)) key = 'neutral';
      if (/(^|\W)west ham(\W|$)/.test(title)) key = 'championship';
    }
    var result = Object.assign({}, BASE, profiles[key], inkOf(product, variant));
    result.season = season;
    result.variantKind = variantKind(product, variant);
    result.matchReason = category ? 'category' : explicitLeague ? 'league-tag' : detectedClub ? 'club' : 'fallback';
    result.printEligible = isPrintEligible(product);
    if (!result.printEligible) return result;
    var reference = referenceTypography(product, result);
    if (reference.fontFamily && !reference.nameFontFamily) reference.nameFontFamily = reference.fontFamily;
    return Object.assign(result, reference);
  }
  function hasExplicitBackAlt(image) {
    var alt = normalize(image.alt || image.altText);
    if (image.printed === true || /(^|\W)(floque|flocage|nameset|printed|personnalise)(\W|$)/.test(alt)) return false;
    if (!/(^|\W)(dos|back|rear|arriere)(\W|$)/.test(alt)) return false;
    // A front-and-back collage is not a usable single back view.
    if (/(^|\W)(avant|front|face|collage|detail|details|zoom)(\W|$)/.test(alt)) return false;
    return true;
  }
  function imageMatchesVariant(image, product, variant) {
    var variantIds = image.variantIds || image.variant_ids;
    if (variantIds && variantIds.length && variant && variant.id && !variantIds.some(function (id) { return idOf(id) === idOf(variant.id); })) return false;
    var kind = variantKind(product, variant);
    var imageKind = variantKind({ title: image.alt || image.altText || '' }, null);
    return kind === 'default' || imageKind === 'default' || kind === imageKind;
  }
  function resolveBackImage(product, variant, images) {
    product = product || {};
    if (!isPrintEligible(product)) return null;
    images = Array.isArray(images) ? images : Array.isArray(product.images) ? product.images : [];
    var reference = referencePhoto(product, variant);
    if (reference) {
      var matched = images.find(function (image) {
        var actualUrl = String(image.url || image.src || '').split('?')[0].replace(/^https?:/, '');
        var referenceUrl = String(reference.url || '').split('?')[0].replace(/^https?:/, '');
        return idOf(image.id || image.mediaId) === idOf(reference.mediaId) || (reference.imageId && idOf(image.id) === idOf(reference.imageId)) || (!!referenceUrl && actualUrl === referenceUrl);
      });
      if (matched) return Object.assign({}, reference, { mediaId: matched.id || matched.mediaId, variantKind: variantKind(product, variant), source: 'verified', calibrated: true, geometry: Object.assign({}, reference.geometry) });
    }
    return null;
  }

  function hasOfficialReference(profile) {
    return !!(profile && profile.printEligible === true && profile.verifiedFont === true &&
      profile.referenceIncomplete !== true && profile.provisionalReference !== true &&
      (profile.glyphPreserveColor === true || profile.inkSource === 'reference'));
  }

  function previewFamily(product) {
    var monaco = reviewedMonacoKit(product);
    if (monaco && monaco.kit === 'away') return 'maillot monaco exterieur 26/27';
    return normalize(product.title).replace(/\b(?:player version|version player|version pro|player|fan)\b/g, '').replace(/\s+/g, ' ').trim();
  }
  function isShortSleeve(product) {
    var text = normalize([product.title].concat(listOf(product.tags)).join(' '));
    if (/\b(manches? longues?|long sleeves?|longsleeve|sleeveless|sans manches?)\b/.test(text)) return false;
    return /\b(manches? courtes?|short sleeves?|shortsleeve)\b/.test(text);
  }
  function isFanShortSleeveSource(product, variant, photo) {
    return isPrintEligible(product) && isShortSleeve(product) && variantKind(product, variant) === 'fan' && photo?.variantKind === 'fan';
  }
  function referenceSignature(profile) {
    return JSON.stringify([profile.referenceLabel, profile.glyphSet, profile.fontFamily, profile.nameFontFamily,
      profile.numberFontFamily, profile.ink, profile.glyphPreserveColor, profile.colorFonts, profile.nameFontLayers]);
  }
  var previewReferences = Object.create(null);
  function registerPreviewReferences(data) {
    if (data && data.products && typeof data.products === 'object') previewReferences = data.products;
  }
  function resolvePreviewReference(product, variant, images) {
    var profile = resolve(product, variant);
    if (!hasOfficialReference(profile) || !isShortSleeve(product)) return null;
    var candidates = [];
    var productVariants = Array.isArray(product.variants) ? product.variants : [variant];
    ['fan'].forEach(function (kind) {
      var referenceVariant = productVariants.find(function (entry) { return variantKind(product, entry) === kind; });
      if (!referenceVariant) return;
      var photo = resolveBackImage(product, referenceVariant, images);
      if (photo && isFanShortSleeveSource(product, referenceVariant, photo)) candidates.push(Object.assign({}, photo, { sleeveLength: 'short' }));
    });
    var mapping = previewReferences[idOf(product.productId || product.id)];
    if (mapping && normalize(mapping.title) === normalize(product.title) && mapping.handle === product.handle) {
      var source = mapping.source;
      if (source && previewFamily(source.product) === previewFamily(product)) {
        var sourceProfile = resolve(source.product, source.variant);
        if (hasOfficialReference(sourceProfile) && isFanShortSleeveSource(source.product, source.variant, source.photo) && referenceSignature(sourceProfile) === referenceSignature(profile) && source.photo?.url && source.photo?.geometry) {
          candidates.push(Object.assign({}, source.photo, { sleeveLength: 'short', referenceProductId: idOf(source.product.id), referenceHandle: source.product.handle }));
        }
      }
    }
    return candidates.length ? { profile: profile, photo: candidates[0] } : null;
  }

  return { resolve: resolve, resolveBackImage: resolveBackImage, resolvePreviewReference: resolvePreviewReference,
    previewFamily: previewFamily, referenceSignature: referenceSignature, registerPreviewReferences: registerPreviewReferences,
    isShortSleeve: isShortSleeve, isFanShortSleeveSource: isFanShortSleeveSource,
    isPrintEligible: isPrintEligible, hasOfficialReference: hasOfficialReference, registerGrid: registerGrid, profiles: profiles, verifiedPhotos: verifiedPhotos };
}));
